import React, { useContext, useState, useRef, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from 'app/AuthContext';
import { FormModal, CreateAccountForm } from 'sub-components';
import { getEnvConfig } from 'lib/utils';



const CreateAccountModal = (props) => {
  const { authToken, userMetadata, logout } = useContext(AuthContext);
  const [actionCompleted, setActionCompleted] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [actionCompletedType, setActionCompletedType] = useState(null);
  const navigate = useNavigate();

  const messaging = getEnvConfig().messaging;

  const handleActionCompleted = (actionType) => {
    if (actionType) { setActionCompletedType(actionType); }
    setActionCompleted(true);
  };

  useEffect(() => {
    if (actionCompletedType === "signup_user" && userMetadata) {
      navigate(`/onboarding/${userMetadata?.id}`);
    }
  }, [actionCompletedType, userMetadata]);

  return (
    <FormModal
      isToggleOn={props.isSignUpToggleOn}
      handleClick={props.handleClick}
      onClose={() => {
        setActionCompleted(false);
      }}
      actionCompleted={actionCompleted}
      title={messaging.sign_up.ui.title}
      successfulActionTitle={actionCompletedType === "signup_native_user" ? messaging.sign_up.ui.success.title : "Welcome to the community!"}
      successfulActionMessage={
        actionCompletedType === "signup_native_user" ? (
          <div>{messaging.sign_up.ui.success.msg}</div>
        ) : (
          actionCompletedType === "signup_user" ? (
            <div>I'm going to suck and ask you to fill out yet another form.</div>
          ) : null // Added null to handle the case where actionCompletedType doesn't match either condition
        )
      }>
      <CreateAccountForm handleSignInClick={props.handleSignInClick} onActionCompleted={handleActionCompleted} />
    </FormModal>
  );
};

export default CreateAccountModal;